import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Renewal({ outline, ...props }: IconProps): JSX.Element {
  return outline ? (
    <Renewal.Outline {...props} />
  ) : (
    <Renewal.Solid {...props} />
  );
}

Renewal.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M21.0842 10.3597C20.8681 4.72663 16.2282 0.208008 10.6158 0.208008C4.78803 0.208008 0.0507812 4.94163 0.0507812 10.7694C0.0507812 16.5971 4.78803 21.3308 10.6158 21.3308C12.9289 21.3308 15.1253 20.5968 16.9676 19.2063C17.4673 18.8298 17.5671 18.1192 17.1898 17.6189C16.8139 17.1201 16.1026 17.0197 15.6022 17.3971C14.156 18.4867 12.4325 19.0632 10.6151 19.0632C6.03788 19.0632 2.31753 15.3427 2.31753 10.7655C2.31753 6.18822 6.03811 2.46787 10.6151 2.46787C15.0512 2.46787 18.6725 5.97086 18.8871 10.3585H17.1502L18.5959 12.7564L20.0416 15.1549L21.4867 12.7564L22.9318 10.3585L21.1535 10.359L21.0842 10.3597Z"
          stroke="currentColor"
          strokeWidth="1.5"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Renewal.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          d="M21.0842 10.3597C20.8681 4.72663 16.2282 0.208008 10.6158 0.208008C4.78803 0.208008 0.0507812 4.94163 0.0507812 10.7694C0.0507812 16.5971 4.78803 21.3308 10.6158 21.3308C12.9289 21.3308 15.1253 20.5968 16.9676 19.2063C17.4673 18.8298 17.5671 18.1192 17.1898 17.6189C16.8139 17.1201 16.1026 17.0197 15.6022 17.3971C14.156 18.4867 12.4325 19.0632 10.6151 19.0632C6.03788 19.0632 2.31753 15.3427 2.31753 10.7655C2.31753 6.18822 6.03811 2.46787 10.6151 2.46787C15.0512 2.46787 18.6725 5.97086 18.8871 10.3585H17.1502L18.5959 12.7564L20.0416 15.1549L21.4867 12.7564L22.9318 10.3585L21.1535 10.359L21.0842 10.3597Z"
          className="icon-primary"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
